import { lazy } from 'react'

export const MenuLazy = lazy(() => import('./Menu'))
